import React from "react";
import Render from "../../utilities/Render";

const Breakpoints = props => {
  return (
    <div>
      <div className="breakpoint sm">sm</div>
      <div className="breakpoint md">md</div>
      <div className="breakpoint lg">lg</div>
      <div className="breakpoint xl">xl</div>
    </div>
  );
};

if (
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1")
) {
  Render.Component("#breakpoints-react", null, Breakpoints);
}

export default Breakpoints;
